export default __webpack_public_path__ + "static/media/9.eced0d1a.JPG";